import store from '../store'
import Vue from 'vue'
export default async function () {
  let openid = new URL(location.href).searchParams.get('openid')
  let invite = new URL(location.href).searchParams.get('invite')
  let token = new URL(location.href).searchParams.get('token')
  if (openid) store.commit('setOpenid', openid)
  if (!store.state.token && !token) return
  store.commit('login', store.state.token ?? { token: token })
  let user = await Vue.prototype.$apiAjax.getData('/user/me', {
    params: invite ? {
      invite: invite
    } : {}
  }).catch(() => {
    store.commit('logout')
  })
  if (user) {
    if (!user.openid && openid) {
      user.openid = openid
      await Vue.prototype.$apiAjax.put(`/user/${user.id}`, { openid: openid }).catch(e => {})
    }
    store.commit('setUser', user)
  }
}
